import React, { useContext, useEffect, useRef, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import DatePicker from 'react-date-picker';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { actions } from '../../../../../../../context';
import { faCircle, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { PermissionsContext } from '../PracticeConversions';
import BtxSwitch from '../../../../../../Forms/BtxSwitch';
import hasPermission from '../../../../../../Shared/hasPermission';
import ConfirmUpdateIsExpeditedModal from '../Modals/ConfirmUpdateIsExpeditedModal';

// TODO: This is an update when click away funciton and there is probably a more elegant solution
const useOutsideAlerter = (ref, outsideClickFunction) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                ref.current &&
                !ref.current.contains(event.target) &&
                !Array.from(ref.current.children).contains(event.target)
            )
                outsideClickFunction();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line
    }, [ref]);
};

const Milestone = ({ milestone, heading }) => {
    const dispatch = useDispatch();

    const { canManageConversionSteps } = useContext(PermissionsContext);

    const [selectedStep, setSelectedStep] = useState('');
    const [isExpeditedModalOpen, setIsExpeditedModalOpen] = useState(false);

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, () => setSelectedStep(''));

    const [targetDate, setTargetDate] = useState(new Date());

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canSeeAdmin = hasPermission(
        ['ViewAllPractices', 'Dashboard'],
        permissions
    );

    const milestoneComplete = isMilestoneComplete(milestone);

    //render and handle milestone step completion
    const getMilestoneIcon = (
        milestoneId = '',
        type,
        status = false,
        statusName = '',
        statusDate = 0,
        previousStepComplete = false
    ) => (
        <>
            <form id={`${milestoneId}${statusName}`}>
                <div
                    className={classNames(
                        'position-absolute bg-light text-dark rounded border p-3 shadow-lg d-flex justify-content-end flex-wrap',
                        {
                            invisible:
                                selectedStep !== `${milestoneId}${statusName}`,
                        }
                    )}
                    style={popUpStepStyle}>
                    <div className="text-left w-100 h-75">
                        <div className="d-flex justify-content-between">
                            <h5>Complete Task: {statusName}</h5>
                        </div>
                        <textarea
                            name="details"
                            className="rounded w-100 p-2"
                            style={{ resize: 'none' }}
                            placeholder="Add Details..."
                            rows={6}
                        />
                    </div>
                    <div>
                        <Button
                            color="danger"
                            onClick={() => {
                                document
                                    .getElementById(
                                        `${milestoneId}${statusName}`
                                    )
                                    .reset();
                                setSelectedStep('');
                            }}>
                            Cancel
                        </Button>
                        &emsp;
                        <Button
                            color="success"
                            className="d-inline"
                            onClick={() =>
                                updateMilestone(
                                    milestoneId,
                                    type,
                                    statusName,
                                    dispatch,
                                    setSelectedStep
                                )
                            }>
                            Complete
                        </Button>
                    </div>
                </div>
                <span
                    className={classNames('p-2', {
                        hoverable: canManageConversionSteps || status,
                        'step-complete': status,
                    })}>
                    <span
                        className={classNames(
                            'step-complete-icon rounded-circle p-2',
                            {
                                'fa-icon-container':
                                    canManageConversionSteps &&
                                    !status &&
                                    previousStepComplete,
                                hoverable:
                                    canManageConversionSteps || status === true,
                            }
                        )}
                        title={
                            previousStepComplete
                                ? `Complete this task`
                                : `Complete previous tasks to complete this task`
                        }
                        onClick={() =>
                            !status &&
                            canManageConversionSteps &&
                            previousStepComplete
                                ? setSelectedStep(`${milestoneId}${statusName}`)
                                : null
                        }>
                        <FontAwesomeIcon
                            size="lg"
                            icon={status ? faCheckCircle : faCircle}
                            className={classNames('', {
                                'text-success bg-light rounded-circle': status,
                                'text-scondary': !status,
                            })}
                        />
                    </span>
                    <span className="step-complete-date">
                        Completed{' '}
                        {moment.unix(statusDate).utc().format('M/D/YY')}
                    </span>
                </span>
            </form>
        </>
    );

    const handleTargetDateClick = (milestone, fieldName) => {
        setSelectedStep(`${milestone.id}${fieldName}`);
        if (milestone.targetDate > 0)
            setTargetDate(moment.unix(milestone.targetDate));
        else setTargetDate(moment().toDate());
    };

    // TODO: break this out into whatever it needs to be
    //render and handle target date
    const getTargetDateElement = (milestone, type, fieldName = 'target') => (
        <form id={`${milestone.id}${fieldName}`}>
            <div
                style={popUpTargetStyle}
                className={classNames(
                    `position-absolute bg-light text-dark rounded p-3 shadow-lg`,
                    {
                        'd-none':
                            selectedStep !== `${milestone.id}${fieldName}`,
                    }
                )}>
                <h5 className="text-left">Set Target Date</h5>
                <textarea
                    name="details"
                    className="rounded w-100 p-2"
                    style={{ resize: 'none' }}
                    placeholder="Add Details..."
                    rows={6}
                />
                <div className="text-left bg-light py-3 rounded bg-white">
                    <DatePicker
                        value={new Date(targetDate)}
                        onChange={setTargetDate}
                    />
                </div>
                <br />
                <div>
                    <Button
                        color="danger"
                        onClick={() => {
                            document
                                .getElementById(`${milestone.id}${fieldName}`)
                                .reset();
                            setSelectedStep('');
                        }}>
                        Cancel
                    </Button>
                    &emsp;
                    <Button
                        color="warning"
                        onClick={() =>
                            updateMilestoneTarget(
                                milestone.id,
                                type,
                                null,
                                dispatch,
                                setSelectedStep
                            )
                        }>
                        Clear Target
                    </Button>
                    &emsp;     
                    <Button
                        color="primary"
                        className="d-inline"
                        onClick={() =>
                            updateMilestoneTarget(
                                milestone.id,
                                type,
                                targetDate,
                                dispatch,
                                setSelectedStep
                            )
                        }>
                        Set Target
                    </Button>
                </div>
            </div>
            <span
                className={classNames('p-1 hoverable', {
                    'target-date': !isMilestoneComplete(milestone),
                })}
                title={
                    !isMilestoneComplete(milestone)
                        ? `Set target date for this ${type.toLowerCase()}`
                        : null
                }
                onClick={() => handleTargetDateClick(milestone, fieldName)}>
                {milestone.targetDate > 0
                    ? moment
                          .unix(milestone.targetDate)
                          .utc()
                          .format('MMM D, YYYY')
                    : `Not Set`}
            </span>
        </form>
    );

    return (
        <>
            <ConfirmUpdateIsExpeditedModal
                isOpen={isExpeditedModalOpen}
                milestone={milestone}
                heading={heading}
                closeBehavior={() => setIsExpeditedModalOpen(false)}
            />
            <Col lg="4" className="text-center py-2">
                <Row className="h-100">
                    <Col
                        lg="11"
                        sm="12"
                        className="sc-glass rounded text-light sc-shadow h-100 py-2 bg-dark-opacity-">
                        <Row className="border-bottom border-light">
                            <Col
                                lg="12"
                                className="text-center"
                                title={
                                    milestoneComplete
                                        ? `Completed ${moment
                                              .unix(milestone.deliveredDate)
                                              .format('M/D/YYYY h:mma')}`
                                        : null
                                }>
                                <h3 className="hide-overflow">
                                    {heading}
                                    {milestoneComplete && (
                                        <>
                                            &nbsp;
                                            <FontAwesomeIcon
                                                className="text-light"
                                                icon={faCheck}
                                            />
                                        </>
                                    )}
                                </h3>
                            </Col>
                        </Row>
                        <Row className="d-flex flex-wrap justify-content-center text-left">
                            <Col {...labelProps}>
                                {heading.toLowerCase() === 'trial'
                                    ? 'Scheduled Date'
                                    : 'Go-Live Date'}
                            </Col>
                            <Col {...valueColProps}>
                                {getTargetDateElement(milestone, heading)}
                            </Col>
                            <Col {...labelProps}>Data Gathered</Col>
                            <Col
                                {...valueColProps}
                                title={getMilestoneTitle(
                                    milestone.dataGathered,
                                    milestone.dataGatheredDate
                                )}>
                                {getMilestoneIcon(
                                    milestone.id,
                                    heading,
                                    milestone.dataGathered,
                                    'Data Gathering',
                                    milestone.dataGatheredDate,
                                    true
                                )}
                            </Col>
                            <Col {...labelProps}>Conversion</Col>
                            <Col
                                {...valueColProps}
                                title={getMilestoneTitle(
                                    milestone.conversionCompleted,
                                    milestone.conversionCompletedDate
                                )}>
                                {getMilestoneIcon(
                                    milestone.id,
                                    heading,
                                    milestone.conversionCompleted,
                                    'Conversion',
                                    milestone.conversionCompletedDate,
                                    milestone.dataGathered
                                )}
                            </Col>
                            <Col {...labelProps}>Q.A.</Col>
                            <Col
                                {...valueColProps}
                                title={getMilestoneTitle(
                                    milestone.qaCompleted,
                                    milestone.qaCompletedDate
                                )}>
                                {getMilestoneIcon(
                                    milestone.id,
                                    heading,
                                    milestone.qaCompleted,
                                    'Q.A.',
                                    milestone.qaCompletedDate,
                                    milestone.conversionCompleted
                                )}
                            </Col>
                            <Col {...labelProps}>Delivered</Col>
                            <Col
                                {...valueColProps}
                                title={getMilestoneTitle(
                                    milestone.delivered,
                                    milestone.deliveredDate
                                )}>
                                {getMilestoneIcon(
                                    milestone.id,
                                    heading,
                                    milestone.delivered,
                                    'Delivered',
                                    milestone.deliveredDate,
                                    milestone.qaCompleted
                                )}
                            </Col>
                            <Col {...labelProps}>Is Expedited?</Col>
                            <Col {...valueColProps}>
                                <BtxSwitch
                                    value={milestone?.isExpedited}
                                    disabled={
                                        isMilestoneComplete(milestone) ||
                                        !canSeeAdmin
                                    }
                                    onChange={() =>
                                        setIsExpeditedModalOpen(true)
                                    }
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </>
    );
};
//milestone functions
const getMilestoneTitle = (status, date) =>
    status
        ? `Task completed ${moment.unix(date).format('M/D/YYYY h:mm a')}`
        : null;

const updateMilestone = (
    milestoneId,
    type,
    step,
    dispatch,
    setSelectedStep
) => {
    const newType = type.replaceAll(' ', '').toLowerCase();
    const newStep = step.replaceAll('.', '').split(' ')[0].toLowerCase();
    const formElement = document.getElementById(`${milestoneId}${step}`);
    const message = formElement.elements[0].value;
    
    dispatch(
        actions.conversions.updateMilestone(
            milestoneId,
            newType,
            newStep,
            message
        )
    ).then(() => {
        dispatch(actions.toggle.triggerPracticeRefresh());
        dispatch(actions.toggle.activitiesRefresh());
        setSelectedStep(``);
        formElement.reset();
    });
};

const updateMilestoneTarget = (
    milestoneId,
    type,
    targetDate,
    dispatch,
    setSelectedStep
) => {
    const newType = type.replaceAll(' ', '').toLowerCase();
    const formElement = document.getElementById(`${milestoneId}target`);
    const message = formElement.elements[0].value;
    
    dispatch(
        actions.conversions.updateMilestoneTarget(
            milestoneId,
            newType,
            targetDate === null ? null : moment(targetDate).unix(),
            message
        )
    ).then(() => {
        dispatch(actions.toggle.triggerPracticeRefresh());
        dispatch(actions.toggle.activitiesRefresh());
        setSelectedStep(``);
        formElement.reset();
    });
};

const isMilestoneComplete = ({
    dataGathered,
    conversionCompleted,
    qaCompleted,
    delivered,
}) => dataGathered && conversionCompleted && qaCompleted && delivered;

//milestone classes
const commonClasses = `text-wrap d-inline py-2 px-4`;
const labelClass = `${commonClasses}`;
const valueClass = `text-right ${commonClasses}`;
const popUpStepStyle = {
    right: '-1rem',
    width: '25rem',
    marginTop: '-15rem',
};
const popUpTargetStyle = {
    right: '-1rem',
    width: '25rem',
    marginTop: '-24rem',
};
const labelWidth = 6;
const valueWidth = 6;
const labelProps = {
    lg: labelWidth,
    md: labelWidth,
    sm: labelWidth,
    xs: labelWidth,
    className: labelClass,
};
const valueColProps = {
    lg: valueWidth,
    md: valueWidth,
    sm: valueWidth,
    xs: valueWidth,
    className: valueClass,
};

export default Milestone;
